import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-signature',
  template: `
  <div>
    <h2>If you are not automatically transferred to the signature page, please click the below button</h2>
    <button (click)="reroute()" style="background-color: #4F6177; color: white; padding: 10px 20px; border: none; border-radius: 5px; cursor: pointer;">Click here</button>
  </div>
  `,
  styles: [`
    div {
      background-color: #f0f0f0;
      padding: 20px;
      border-radius: 5px;
      margin: 20px;
    }
    h2 {
      color: #333;
    }
    p {
      font-size: 16px;
    }
  `]
})
export class SignatureComponent implements OnInit {
  documentId: string;
  currentDomain: string;
  baseUrl: string;

  constructor(private route: ActivatedRoute, private http: HttpClient) {
    this.currentDomain = window.location.host;

    if (this.currentDomain == 'localhost:4200')
      this.currentDomain = 'localhost:5001'

    this.baseUrl = 'https://' + this.currentDomain;
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(async params => {
      this.documentId = await this.getDocumentId();
      this.reroute(); // Trigger rerouting on initialization
    });
  }

  async reroute(): Promise<void> {
    if (!this.documentId) return; // Skip rerouting if documentId is not available
    try {
      const accessLink = await this.generateAccessLink(this.documentId);
      window.location.href = accessLink;
    } catch (error) {
      console.error('Error generating access link:', error);
      // Handle error here (e.g., display an error message to the user)
    }
  }

  async getDocumentId(): Promise<string> {
    const queryParams = new URLSearchParams(window.location.search);
    return queryParams.get('documentid');
  }

  async generateAccessLink(docId: string): Promise<string> {
    const apiUrl = `${this.baseUrl}/api/Sign/secondSignerAccessLink?docId=${docId}`;
  
    try {
      const response: any = await this.http.get(apiUrl).toPromise();
      return response.link;
    } catch (error) {
      console.error('Error generating access link:', error);
      throw error;
    }
  }
}
